import * as React from 'react';
import Box from '@mui/material/Box';
import { StyledTreeItem } from '../StyledTreeItem';

interface ListItemBuilderProps {
	title: string;
	data: any;
	toggleDrawer: (open: boolean) => void;
}

const ListItemBuilder = (props: ListItemBuilderProps) => {
	return <>
		<Box component="h6" sx={{ margin: '12px' }}>{props.title}</Box>
		{props.data.map((item: string) => {
			return <StyledTreeItem
				key={item}
				nodeId={item}
				labelText={item}
				onClick={() => props.toggleDrawer(false)}
			>
			</StyledTreeItem>
		})}
	</>
}

export default ListItemBuilder;

